'use strict';

var React = require('react');
var useEffectOnce = require('./useEffectOnce-5d273a5b.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

class ElementObserver extends React.PureComponent {
    constructor() {
        super(...arguments);
        this._element = React__default['default'].createRef();
        this._isMounted = false;
        this._io = null;
        this.handleIntersect = (entries) => {
            entries.forEach((entry) => {
                if (this._isMounted) {
                    if (entry.isIntersecting) {
                        if (this.props.onViewEnter) {
                            this.props.onViewEnter();
                        }
                    }
                    else if (typeof this.props.onViewExit === "function") {
                        this.props.onViewExit();
                    }
                }
            });
        };
    }
    render() {
        const _a = this.props, { children, onViewEnter, onViewExit, options } = _a, props = __rest(_a, ["children", "onViewEnter", "onViewExit", "options"]);
        return (React__default['default'].createElement("div", Object.assign({}, props),
            children,
            React__default['default'].createElement("div", { ref: this._element })));
    }
    unobserve() {
        if (this._io !== null) {
            if (this._element.current !== null) {
                this._io.unobserve(this._element.current);
            }
        }
    }
    componentDidMount() {
        this._isMounted = true;
        this._observe();
    }
    componentWillUnmount() {
        this._isMounted = false;
        if (this._io !== null) {
            this._io.disconnect();
        }
    }
    getElementRef() {
        return this._element.current;
    }
    _observe() {
        if (window !== undefined &&
            IntersectionObserver !== undefined &&
            this._element.current !== null) {
            this._io = new IntersectionObserver(this.handleIntersect, this.props.options);
            this._io.observe(this._element.current);
        }
    }
    _unobserve(element) {
        if (this._io !== null) {
            this._io.unobserve(element);
        }
    }
}
ElementObserver.defaultProps = {
    options: {},
};

class ElementObserverOnceEnter extends React__default['default'].PureComponent {
    constructor() {
        super(...arguments);
        this._eo = React__default['default'].createRef();
        this.handleViewEnter = () => {
            if (this.props.onViewEnter) {
                this.props.onViewEnter();
            }
            if (this._eo.current !== null) {
                this._eo.current.unobserve();
            }
        };
    }
    render() {
        return (React__default['default'].createElement(ElementObserver, Object.assign({}, this.props, { ref: this._eo, onViewEnter: this.handleViewEnter })));
    }
}

class ElementObserverOnceExit extends React__default['default'].PureComponent {
    constructor() {
        super(...arguments);
        this._eo = React__default['default'].createRef();
        this.handleViewExit = () => {
            if (this.props.onViewExit) {
                this.props.onViewExit();
            }
            if (this._eo.current !== null) {
                this._eo.current.unobserve();
            }
        };
    }
    render() {
        return React__default['default'].createElement(ElementObserver, Object.assign({}, this.props, { ref: this._eo, onViewExit: this.handleViewExit }));
    }
}

const ElementObserverOnceStart = (props) => {
    const { children, onViewEnter, options = {} } = props, divProps = __rest(props, ["children", "onViewEnter", "options"]);
    const _element = React.useRef(null);
    const _io = React.useRef(null);
    const unobserve = React.useCallback(() => {
        if (_io !== null) {
            if (_element.current !== null && _io.current !== null) {
                _io.current.unobserve(_element.current);
            }
        }
    }, []);
    const handleIntersect = React.useCallback((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                if (onViewEnter) {
                    onViewEnter();
                    unobserve();
                }
            }
        });
    }, [onViewEnter, unobserve]);
    const _observe = React.useCallback(() => {
        if (window !== undefined &&
            IntersectionObserver !== undefined &&
            _element.current !== null) {
            _io.current = new IntersectionObserver(handleIntersect, options);
            _io.current.observe(_element.current);
        }
    }, [handleIntersect, options]);
    useEffectOnce.useEffectOnce(() => {
        _observe();
    });
    return (React__default['default'].createElement("div", Object.assign({}, divProps),
        React__default['default'].createElement("div", { ref: _element }),
        children));
};
var OnceStart = React__default['default'].memo(ElementObserverOnceStart);

exports.ElementObserver = ElementObserver;
exports.ElementObserverOnceEnter = ElementObserverOnceEnter;
exports.ElementObserverOnceExit = ElementObserverOnceExit;
exports.OnceStart = OnceStart;
//# sourceMappingURL=OnceStart-83973221.js.map
